<div *ngIf="this.spinnerService.getLoading()" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>
